import {
    basicColumnDef,
    choiceListColumnDef,
    choiceListColumnSettings,
    dateColumnDef,
    dateTimeColumnDef,
    idColumnDef
} from '../common/FilteredTable/tableAndFilterHelpers';
import ColumnTypeFormatCompanyName from '../common/Table/ColumnTypeFormatCompanyName';
import React from 'react';
import moment from 'moment';

const meeting = {
    id: idColumnDef('id', 'meetingId'),
    companyName: {
        ...basicColumnDef('Company Name', 'companyName'),
        mapping: (resources, values) => (values && values.company ? values.company.descriptor : ''),
        mapToDisplayedValue: (resources, values, field, actions) => (
            <ColumnTypeFormatCompanyName actions={actions} values={values} />
        ),
        valueToSortOnMapping: (resources, values) => (values && values.company ? values.company.descriptor : ''),
        searchable: true
    },
    status: {
        ...choiceListColumnDef('Status', 'status', 'communicationStatus'),
        emptyOption: 'Select a status...'
    },
    assigneeId: {
        ...choiceListColumnDef('Assignee', 'assigneeId', 'communicationAssignee', {
            renderAsBasicText: true
        }),
        emptyOption: 'Select an assignee...',
        searchable: true,
        mapping: (resources, values) => (values && values.assigneeId ? values.assigneeId.toString() : '-')
    },

    endDate: {
        ...dateColumnDef('End Time', 'endDate')
    },
    activityRegarding: {
        ...choiceListColumnDef('Activity Regarding', 'activityRegarding', 'communicationActivityRegarding', {
            renderAsBasicText: true,
            displayEmptyAs: '-'
        }),
        emptyOption: 'Select an activity regarding...',
        searchable: true
    },
    body: {
        ...basicColumnDef('Details', 'body'),
        type: 'textarea',
        mapToDisplayedValue: (resources, values) => (values && values.body ? values.body.substring(0, 100) : '')
    },
    location: {
        ...choiceListColumnDef('Location', 'location', 'meetingLocation'),
        emptyOption: 'Select a meeting location...'
    },
    personId: {
        ...choiceListColumnDef('Person', 'personId', 'peopleOptions'),
        emptyOption: 'Select a Person...',
        noOptionsText: 'No people in company'
    },
    eventMethod: {
        ...basicColumnDef('Event Method', 'eventMethod'),
        ...choiceListColumnSettings('communicationMeetingMode'),
        emptyOption: 'Select an Event Method...'
    },
    opportunityId: {
        ...basicColumnDef('Opportunity', 'opportunityId'),
        ...choiceListColumnSettings('opportunityOptions'),
        emptyOption: 'Select an Opportunity...',
        noOptionsText: 'No opportunities in company'
    },
    subject: {
        ...basicColumnDef('Subject', 'subject'),
        searchable: true
    },
    note: {
        ...basicColumnDef('Details', 'note'),
        type: 'textarea'
    },
    engageNotes: {
        ...basicColumnDef('Notes', 'engageNotes'),
        type: 'textarea'
    },
    startDate: {
        ...dateTimeColumnDef('Meeting Date', 'startDate', true),
        searchable: true
    },
    startTime: {
        ...basicColumnDef('Meeting Time', 'startTime'),
        mapping: (resources, values) => moment(values.startDate).format(process.env.REACT_APP_TIME_FORMAT)
    },
    meetingMode: {
        ...choiceListColumnDef('Meeting Type', 'meetingMode', 'communicationMeetingMode'),
        emptyOption: 'Select a meeting mode...',
        searchable: true
    },
    feedback: {
        ...basicColumnDef('Feedback', 'feedback')
    },
    rating: {
        ...choiceListColumnDef('Rating', 'rating', 'communicationAppointmentRating'),
        emptyOption: 'Select an rating...',
        searchable: true
    },
    action: {
        ...choiceListColumnDef('Action', 'action', 'meetingAction')
    }
};

export default meeting;
